import { createVirtualTaskId } from "./types";

// Unified transition workflow configuration
const TRANSITION_WORKFLOW_CONFIG = {
  kickoff: {
    id: createVirtualTaskId("kickoff"),
    title: "Kickoff",
    taskType: {
      label: "Kickoff",
      value: "TRANSITION_KICKOFF",
    },
    children: [
      "Schedule Initial Meeting",
      "Review Client Requirements",
      "Define Project Scope",
      "Assign Team Members",
      "Create Project Timeline",
    ],
  },
  "access-provisioning": {
    id: createVirtualTaskId("access-provisioning"),
    title: "Access/Provisioning",
    taskType: {
      label: "Access Provisioning",
      value: "TRANSITION_ACCESS",
    },
    children: [
      "Create User Accounts",
      "Configure System Access",
      "Setup Security Permissions",
    ],
  },
  transition: {
    id: createVirtualTaskId("transition"),
    title: "Transition",
    taskType: {
      label: "Transition",
      value: "TRANSITION_TRANSITION",
    },
    children: [
      "Migrate Existing Data",
      "Transfer Account Holdings",
      "Update Client Records",
    ],
  },
  launch: {
    id: createVirtualTaskId("launch"),
    title: "Launch",
    taskType: {
      label: "Launch",
      value: "TRANSITION_LAUNCH",
    },
    children: [
      "Execute Go-Live Plan",
      "Monitor System Performance",
      "Conduct User Training",
      "Provide Support Documentation",
    ],
  },
  "post-launch": {
    id: createVirtualTaskId("post-launch"),
    title: "Post-Launch",
    taskType: {
      label: "Post Launch",
      value: "TRANSITION_POST_LAUNCH",
    },
    children: ["Gather User Feedback", "Monitor Performance Metrics"],
  },
} as const;

export const ROOT_TASK_IDS = Object.keys(TRANSITION_WORKFLOW_CONFIG);

export const ROOT_TASK_DEFINITIONS = Object.values(
  TRANSITION_WORKFLOW_CONFIG
).map((config) => ({
  id: config.id,
  title: config.title,
}));

export const ROOT_TASK_TYPE_MAPPING = Object.fromEntries(
  Object.values(TRANSITION_WORKFLOW_CONFIG).map((config) => [
    config.id,
    config.taskType,
  ])
) as Record<string, { label: string; value: string }>;

export const CHILDREN_CATALOG = Object.fromEntries(
  Object.values(TRANSITION_WORKFLOW_CONFIG).map((config) => [
    config.title,
    config.children,
  ])
);
